<template>
  <div class="fill-height">
    <v-row class="ma-0 pa-4">
      <v-col cols="12">
        <AvailableAssessmentList class="mb-10" />
      </v-col>

      <v-col cols="12">
        <AssessmentHistory class="mb-10" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AvailableAssessmentList from "@/app/quiz-module/components/AvailableAssementList";
import AssessmentHistory from "@/app/quiz-module/components/AssessmentHistory";

export default {
  name: "AssessmentsPage",
  components: {
    AssessmentHistory,
    AvailableAssessmentList,
  },
};
</script>

<style lang="scss" scoped />
